import React from 'react'

import Layout from '../components/layout'
import FeaturedArticles from '../components/pages/index/FeaturedArticles'


import Clients from '../components/Clients'

import Seo from '../components/seo'


const IndexPage = () => {
  const processRef = React.createRef()

  const scroll = () => {
    processRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  return (
    <Layout extraCss={['/cloud-journey/main-static.css']} extraJs={['/cloud-journey/js/main-static.js']} showContact={false}>
      <Seo title="AWS Cloud Services & Next-Gen Development" />

        <div className="main-container">
            <main>
                <section className="section-1">
                    <div className="lottie phone-only" data-aos="fade-up" data-aos-delay="1000"
                         data-aos-id="animationRocketPhone"
                         id="animationRocketPhone"><img src="cloud-journey-static/assets/rocket-cover.png"/></div>

                    <div className="section-content">
                        <div className="lottie" id="animationClouds"></div>
                        <div className="lottie aos-item" data-aos="fade-up" data-aos-duration="10"
                             data-aos-id="animationRocketIntro" id="animationRocketIntro"></div>
                        <div className="lottie" id="animationRocketLoop" style={{display: 'none'}}></div>
                        <div className="logo"></div>
                        <div className="title">
                            <div className="title-text"><h1>Blast Off <br className="phone-only"/>with Cloudnexa</h1>
                                <h2>Propel your business into the stratosphere with unmatched AWS experience</h2></div>
                        </div>
                        <div className="downarrow phone-only"><img alt="Down Arrow" src="cloud-journey-static/assets/arrow-down.png"/></div>
                    </div>
                </section>
                <section className="section-2">
                    <div className="section-content"><h2 data-aos="fade-down" data-aos-delay="500">Get the most from your
                        cloud
                        journey — no matter where you are on your path — with proven and trusted solutions from the
                        industry-leading AWS Premier Partner.</h2>
                        <div className="col-four">
                            <div className="col" data-aos="fade-up">
                                <div className="col-image"><img alt="configuration icon" className="col-img"
                                                                src="cloud-journey-static/assets/icon-configure.svg"/></div>
                                <div className="col-title">Configure systems faster</div>
                                <div className="col-underline"></div>
                            </div>
                            <div className="col" data-aos="fade-up" data-aos-offset="50">
                                <div className="col-image"><img alt="security shield icon" className="col-img"
                                                                src="cloud-journey-static/assets/icon-risk.svg"/></div>
                                <div className="col-title">Lower<br/>risk</div>
                                <div className="col-underline"></div>
                            </div>
                            <div className="col" data-aos="fade-up" data-aos-offset="100">
                                <div className="col-image"><img alt="two people icon" className="col-img"
                                                                src="cloud-journey-static/assets/icon-support.svg"/>
                                </div>
                                <div className="col-title">Enjoy customer-focused support</div>
                                <div className="col-underline"></div>
                            </div>
                            <div className="col" data-aos="fade-up" data-aos-offset="150">
                                <div className="col-image"><img alt="money icon" className="col-img"
                                                                src="cloud-journey-static/assets/icon-value.svg"/></div>
                                <div className="col-title">Achieve long-term<br/>value</div>
                                <div className="col-underline"></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-3">
                    <div className="section-content"><h3 data-aos="fade-right">3 Ways to Gain Altitude on the AWS
                        Cloud</h3>
                        <p data-aos="fade-right" data-aos-offset="50">Wherever your ambitions take you, we have the
                            scalable and
                            flexible capabilities to help you get there — and beyond.</p></div>
                </section>
                <section className="section-4">
                    <div className="section-content">
                        <div className="static" id="animation2Static"></div>
                        <div className="lottie" data-aos="fade-in" data-aos-id="animation2Intro" data-aos-offset="350"
                             id="animation2Intro"></div>
                        <div className="lottie" data-aos-id="animation3Loop" id="animation2Loop"
                             style={{display: 'none'}}></div>
                        <div className="cityscape phone-hide"></div>
                        <div className="numbered-title" data-aos="fade-right"><img className="section-04-number-1 number"
                                                                                   src="cloud-journey-static/assets/1.png"/>
                            <div className="numbered-text" data-aos="fade-left"><h3>Migration</h3>
                                <p>Get mature tools, resources and unmatched support for a successful, streamlined
                                    migration.</p></div>
                        </div>
                        <div className="card-holder">
                            <div className="card card-1" section5lottie="true">
                                <div className="card-image"><img src="cloud-journey-static/assets/icon-tests.svg"/></div>
                                <div className="card-text">Run tests and assessments</div>
                            </div>
                            <div className="card card-2" data-aos="flip-up" data-aos-delay="50">
                                <div className="card-image"><img src="cloud-journey-static/assets/icon-scale.svg"/></div>
                                <div className="card-text">Build a foundation<br/>to scale</div>
                            </div>
                            <div className="card card-3" data-aos="flip-up">
                                <div className="card-image"><img src="cloud-journey-static/assets/icon-move.svg"/></div>
                                <div className="card-text">Move existing applications</div>
                            </div>
                            <div className="card card-4" data-aos="flip-up" data-aos-delay="50">
                                <div className="card-image"><img src="cloud-journey-static/assets/icon-optimize.svg"/></div>
                                <div className="card-text">Optimize<br/>operations</div>
                            </div>
                        </div>
                        <div className="success-story shadowed">
                            <div className="success-story-content">
                                <div className="success-story-content-title">Cloud Success Story:</div>
                                <div className="logo-container logo-container-1"><img alt="One Medical logo"
                                                                                      src="cloud-journey-static/assets/logo-onemedical.png"/>
                                </div>
                                <p>One Medical Passport migrates in a weekend – saving 74% in migration costs</p>
                                <div className="more-button phone-hide" data-aos="fade-left">
                                    <div className="more-button-text">Learn more</div>
                                    <div className="more-button-arrow"><img src="cloud-journey-static/assets/icon-popup.svg"/></div>
                                </div>
                            </div>
                            <div className="success-story-slideout">
                                <div className="success-story-slideout-close phone-hide"></div>
                                <div className="success-story-slideout-content"><p>For One Medical Passport, suspending
                                    normal
                                    operations for days or weeks for a cloud migration would disrupt medical care for
                                    millions
                                    of patients. Cloudnexa helped One Medical Passport migrate to the AWS Cloud quickly —
                                    and
                                    increase revenue by 30%.</p><a
                                    className="read-more"
                                    href="https://www.cloudnexa.com/case-studies/one-medical-passport/"
                                    target="_blank"></a></div>
                            </div>
                        </div>
                        <div className="trophy-text">
                            <div className="trophy-text-item" data-aos="fade-up">AWS Partner Network – Migration
                                Competency
                            </div>
                            <div className="trophy-text-item" data-aos="fade-up">AWS GovCloud Service Delivery Partner
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-5">
                    <div className="section-content">
                        <div className="numbered-title">
                            <div className="section-05-number-2 number" data-aos="fade-right"><img src="cloud-journey-static/assets/2.png"/>
                            </div>
                            <div className="numbered-text" data-aos="fade-left"><h3>Compliance and Security</h3>
                                <p>Meet your security and compliance standards before you move a single workload.</p>
                                <p></p></div>
                        </div>
                        <div className="static" id="animation3Static"></div>
                        <div className="lottie" data-aos="fade-in" data-aos-id="animation3Intro" data-aos-offset="400"
                             id="animation3Intro"></div>
                        <div className="lottie" data-aos-id="animation3Loop" id="animation3Loop"
                             style={{display: 'none'}}></div>
                        <div className="right-comp" data-aos="fade-up">
                            <div className="right-comp-main-icon phone-hide"><img src="cloud-journey-static/assets/icon-compliance.svg"/></div>
                            <div className="right-comp-content">
                                <div className="right-comp-content-group">
                                    <div className="right-comp-content-title">Compliance</div>
                                    <div className="right-comp-content-text">Stay up to date with laws, policies and
                                        regulations
                                        without jeopardizing data, goals or objectives.
                                    </div>
                                    <div className="col-two" data-aos="fade-up" data-aos-anchor="top-bottom">
                                        <div className="col">
                                            <div className="col-image icon-2-1"><img alt="magnifing glass icon"
                                                                                     className="col-img"
                                                                                     data-aos-anchor="top-bottom"
                                                                                     src="cloud-journey-static/assets/icon-2-1.svg"/></div>
                                            <div className="col-title">Thorough<br/>reviews</div>
                                        </div>
                                        <div className="col col-right icon-2-2">
                                            <div className="col-image"><img alt="cloud and server icon"
                                                                            className="col-img"
                                                                            src="cloud-journey-static/assets/icon-2-2.svg"/></div>
                                            <div className="col-title">Training and<br/>testing</div>
                                        </div>
                                    </div>
                                    <div className="col-two" data-aos="fade-up" data-aos-anchor="top-bottom">
                                        <div className="col">
                                            <div className="col-image icon-2-3"><img alt="checklist icon"
                                                                                     className="col-img"
                                                                                     src="cloud-journey-static/assets/icon-2-3.svg"/></div>
                                            <div className="col-title">Frequent<br/>evaluations</div>
                                        </div>
                                        <div className="col col-right">
                                            <div className="col-image icon-2-4"><img alt="tools icon" className="col-img"
                                                                                     src="cloud-journey-static/assets/icon-2-4.svg"/></div>
                                            <div className="col-title">Risk and<br/>vulnerability analysis</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="right-comp" data-aos="fade-up">
                            <div className="right-comp-main-icon phone-hide"><img src="cloud-journey-static/assets/icon-security.svg"/></div>
                            <div className="right-comp-content">
                                <div className="right-comp-content-group">
                                    <div className="right-comp-content-title">Security</div>
                                    <div className="right-comp-content-text">Provision your resources to AWS best
                                        practices with
                                        cloud design assurance and near real-time guidance.
                                    </div>
                                    <div className="col-two" data-aos="fade-up" data-aos-anchor="top-bottom">
                                        <div className="col">
                                            <div className="col-image icon-2-5"><img alt="magnifing glass icon"
                                                                                     className="col-img"
                                                                                     data-aos-anchor="top-bottom"
                                                                                     src="cloud-journey-static/assets/icon-2-5.svg"/></div>
                                            <div className="col-title">Risk<br/>mitigation</div>
                                        </div>
                                        <div className="col col-right">
                                            <div className="col-image icon-2-6"><img alt="cloud and server icon"
                                                                                     className="col-img"
                                                                                     src="cloud-journey-static/assets/icon-2-6.svg"/>
                                            </div>
                                            <div className="col-title">Compliance assessment<br/>and review</div>
                                        </div>
                                    </div>
                                    <div className="col-two" data-aos="fade-up" data-aos-anchor="top-bottom">
                                        <div className="col">
                                            <div className="col-image icon-2-7"><img alt="checklist icon"
                                                                                     className="col-img"
                                                                                     src="cloud-journey-static/assets/icon-2-7.svg"/></div>
                                            <div className="col-title">Enabled auditing<br/>tools</div>
                                        </div>
                                        <div className="col col-right">
                                            <div className="col-image icon-2-8"><img alt="tools icon" className="col-img"
                                                                                     src="cloud-journey-static/assets/icon-2-8.svg"/></div>
                                            <div className="col-title">Configured for federal<br/>medical privacy laws
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="success-story shadowed">
                            <div className="success-story-content">
                                <div className="success-story-content-title">Cloud Success Story:</div>
                                <div className="logo-container logo-container-2"><img alt="Sensiva logo"
                                                                                      src="cloud-journey-static/assets/logo-sensiva.png"/></div>
                                <p>Sensiva Health pivots swiftly to join the<br className="phone-hide"/>COVID-19 fight.
                                </p>
                                <div className="more-button phone-hide" data-aos="fade-left">
                                    <div className="more-button-text">Learn more</div>
                                    <div className="more-button-arrow"><img src="cloud-journey-static/assets/icon-popup.svg"/></div>
                                </div>
                            </div>
                            <div className="success-story-slideout">
                                <div className="success-story-slideout-close"></div>
                                <div className="success-story-slideout-content"></div>
                                <p>When thousands of COVID-19 test kits arrived daily for processing, Sensiva realized its
                                    cloud
                                    platform was falling short. Sensiva turned to Cloudnexa to help it transition quickly
                                    to AWS
                                    while remaining compliant with HIPAA — with no downtime.</p><a
                                className="read-more" href="https://www.cloudnexa.com/case-studies/sensiva/"
                                target="_blank"></a></div>
                        </div>
                        <div className="trophy-text" data-aos="fade-up">
                            <div className="trophy-text-item">AWS Partner Network – Healthcare Competency</div>
                        </div>
                    </div>
                </section>
                <section className="section-6">
                    <div className="section-content">
                        <div className="static" id="animation4Static"></div>
                        <div className="lottie" data-aos="fade-in" data-aos-id="animation4Intro" data-aos-offset="400"
                             id="animation4Intro"></div>
                        <div className="lottie" data-aos-id="animation4Loop" id="animation4Loop"
                             style={{display: 'none'}}></div>
                        <div className="lottie" data-aos-id="animation5" id="animation5"></div>
                        <div className="static" id="animation5Static"></div>
                        <div className="numbered-title">
                            <div className="section-06-number-3 number" data-aos="fade-right"><img src="cloud-journey-static/assets/3.png"/>
                            </div>
                            <div className="numbered-text" data-aos="fade-left"><h3>Managed Solutions</h3>
                                <p>Supercharge your enterprise with solutions tailored<br className="phone-hide"/>to your
                                    unique
                                    business processes.</p></div>
                        </div>
                        <div className="icon-text" data-aos="fade-up">
                            <div className="icon-text-icon support-icon"><img alt="arrows icon"
                                                                              src="cloud-journey-static/assets/icon-managed-support.svg"/></div>
                            <div className="icon-text-content">
                                <div className="icon-text-title">Managed Cloud Support</div>
                                <div className="icon-text-text">Reach for your goals confidently with comprehensive 24/7
                                    support for
                                    your cloud infrastructure.
                                </div>
                            </div>
                        </div>
                        <div className="callout callout-1" data-aos="fade-up">
                            <div className="callout-column two-col">
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-7"><img alt="bell icon"
                                                                                             src="cloud-journey-static/assets/icon-3-7.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Service monitoring</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-9"><img alt="gears icon"
                                                                                             src="cloud-journey-static/assets/icon-3-9.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Technical support</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-11"><img alt="server icon"
                                                                                              src="cloud-journey-static/assets/icon-3-11.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Issue management</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-13"><img alt="checklist icon"
                                                                                              src="cloud-journey-static/assets/icon-3-13.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Managed backups</div>
                                </div>
                            </div>
                            <div className="callout-column two-col">
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-8"><img alt="connected dots icon"
                                                                                             src="cloud-journey-static/assets/icon-3-8.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">System maintenance</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-10"><img alt="magnifying glass icon"
                                                                                              src="cloud-journey-static/assets/icon-3-10.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Security</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-12"><img alt="gears icon"
                                                                                              src="cloud-journey-static/assets/icon-3-12.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Account configuration</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-14"><img alt="cloud icon"
                                                                                              src="cloud-journey-static/assets/icon-3-14.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Cloudscan automatic audits</div>
                                </div>
                            </div>
                        </div>
                        <div className="icon-text" data-aos="fade-right">
                            <div className="icon-text-icon cam-icon"><img alt="arrows icon" src="cloud-journey-static/assets/icon-cam.svg"/>
                            </div>
                            <div className="icon-text-content">
                                <div className="icon-text-title">Cloud Architect <br className="phone-only"/>Manager (CAM)
                                </div>
                                <div className="icon-text-text">Relieve the operational burden of cloud deployments
                                    through shared
                                    responsibility.
                                </div>
                            </div>
                        </div>
                        <div className="callout callout-2" data-aos="fade-up">
                            <div className="callout-column one-col">
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-1"><img alt="magnifying glass icon"
                                                                                             src="cloud-journey-static/assets/icon-3-1.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Evaluation from solution architect</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-2"><img alt="checkmark icon"
                                                                                             src="cloud-journey-static/assets/icon-3-2.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Cloud framework recommendations</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-3"><img alt="connected dots icon"
                                                                                             src="cloud-journey-static/assets/icon-3-3.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Future-proofing and planning</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-4"><img alt="gears icon"
                                                                                             src="cloud-journey-static/assets/icon-3-4.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Technical assistance</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-5"><img alt="connection icon"
                                                                                             src="cloud-journey-static/assets/icon-3-5.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Ongoing communication</div>
                                </div>
                                <div className="callout-column-item">
                                    <div className="callout-column-item-image icon-3-6"><img alt="text icon"
                                                                                             src="cloud-journey-static/assets/icon-3-6.svg"/>
                                    </div>
                                    <div className="callout-column-item-text">Account review services</div>
                                </div>
                            </div>
                        </div>
                        <div className="success-story shadowed">
                            <div className="success-story-content">
                                <div className="success-story-content-title">Cloud Success Story:</div>
                                <div className="logo-container logo-container-3"><img alt="Blue Bin logo"
                                                                                      src="cloud-journey-static/assets/logo-blue-bin.png"/>
                                </div>
                                <p>BlueBin accelerates growth with<br/>modernized infrastructure.</p>
                                <div className="more-button phone-hide" data-aos="fade-left">
                                    <div className="more-button-text">Learn more</div>
                                    <div className="more-button-arrow"><img src="cloud-journey-static/assets/icon-popup.svg"/></div>
                                </div>
                            </div>
                            <div className="success-story-slideout">
                                <div className="success-story-slideout-close"></div>
                                <div className="success-story-slideout-content"><p>Following its migration to AWS, BlueBin
                                    implemented Cloudnexa Managed Cloud Support for proactive 24/7 monitoring, patching
                                    and
                                    support, as well as Cloudnexa Cloud Architect Manager to plan, design and optimize AWS
                                    deployments. Working with Cloudnexa, BlueBin has cut as much as 25% from workloads —
                                    and has
                                    improved its disaster recovery plan.</p><a
                                    className="read-more"
                                    href="https://www.cloudnexa.com/case-studies/bluebin-success-story/"
                                    target="_blank"></a></div>
                            </div>
                        </div>
                        <div className="trophy-text">
                            <div className="trophy-text-item" data-aos="fade-up">AWS Partner Network – Well-Architected
                                Competency
                            </div>
                            <div className="trophy-text-item" data-aos="fade-up">AWS Partner Network – MSP Competency
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-7">
                    <div className="section-content">
                        <div className="lottie" id="animation6"></div>
                        <div className="static" id="animation6Static"></div>
                        <div className="logo-footer" data-aos="fade-right"><img alt="cloudnexa logo"
                                                                                src="cloud-journey-static/assets/logo-cloudnexa-footer.png"/>
                            <p className="logo-footer-text">Cloud by Birth. AWS by Choice.</p></div>
                        <p data-aos="fade-right">Schedule a free cloud consultation and learn how you can earn up to
                            $60,000 to
                            start your AWS migration journey.</p><a className="schedule-button" data-aos="fade-left"
                                                                    href="https://www.cloudnexa.com/contact/"
                                                                    target="_blank">Schedule
                        now</a></div>
                </section>
            </main>
        </div>
      <Clients />

      <FeaturedArticles />
    </Layout>
  )
}

export default IndexPage
